import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import Highcharts from "highcharts";
import HighchartsCode from "highcharts-react-official";
import Alert from "@material-ui/lab/Alert";
import axios from "axios";
import Skeleton from "@material-ui/lab/Skeleton";
import Box from "@material-ui/core/Box";

import { warningColorPrimary } from "assets/jss/material-dashboard-react.js";

export default function BarWasteType(props) {
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(true);

  const [values, setValues] = useState({
    wastes: [],
  });

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  useEffect(() => {
    axios
      .get(`${urlServices}preRegisters/countWastes`, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          setValues({
            ...values,
            wastes: response.data,
          });
          setLoader(false);
        },
        (error) => {
          console.log(error);
          setError(true);
        }
      );
  }, [keyAplication, urlServices]);

  const optionsData = {
    chart: {
      type: "column",
      // width: 440,
    },
    title: {
      text: "",
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.y:1f}</b>",
    },

    xAxis: {
      categories: values.wastes.map((items) => items.name),
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total",
      },
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        stacking: "normal",
        dataLabels: {
          enabled: true,
          // format: "<b>{point.name}</b>: {point.y:1f} Horas ({point.percentage:.1f}%) ",
          format: "<b>{point.y:1f}</b> ",
          style: {
            color:
              (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
              "black",
          },
        },
      },
    },
    series: [
      {
        name: "Total",
        color: warningColorPrimary[1],
        data: values.wastes.map((items) => items.count),
      },
    ],
  };

  return (
    <Fragment>
      {error ? (
        <Alert severity="error">Error en la consulta con el servidor.</Alert>
      ) : (
        ""
      )}
      {!loader ? (
        <HighchartsCode highcharts={Highcharts} options={optionsData} />
      ) : (
        <Box sx={{ width: "100%", marginTop: "20%" }}>
          <Skeleton width="100%" height={200} />
        </Box>
      )}
    </Fragment>
  );
}
